<div class="flex justify-content-end w-full">
    @if (isAllowed['folder.update']) {
        <app-button
            icon="pi-print"
            label="folder.doctorRecords.print"
            (clickEvent)="showDoctorRecordsDialog()"
        ></app-button>
    }
</div>
@if (folderId) {
    <app-table
        #doctorRecordTable
        tableKey="folderDoctorRecords"
        [gridData]="$any(doctorRecords())"
        [columns]="columns"
        translatePrefix="folder.doctorRecords."
        [showSearch]="true"
        [showColumnVisiblity]="true"
        [showExport]="true"
        [resource]="'doctorWork'"
        (deleteCallbackWithEvent)="delete($event)"
        (detailCallback)="detail($event)"
        [showDetail]="store.isAllowed('doctorWork.update')()"
        [showDelete]="store.isAllowed('doctorWork.delete')() && folderStore.canEdit()"
        [additionalFilter]="additionalFilters()"
        [refreshCallback]="store.api.getWorks"
    >
        <ng-template pTemplate="workData.state" let-data="data">
            <app-tag [label]="'workData.common.enum.workVisitState.' + data"
                [severity]="$any(workVisitStateColor)[data] || undefined" [rounded]="true"></app-tag>
        </ng-template>
        <ng-template pTemplate="diagnoses" let-data="data">
            @for (diagnose of data; track $index) {
                <p-chip
                    [label]="diagnose?.code || ''"
                    [pTooltip]="diagnose?.name || ''"
                ></p-chip>
            }
        </ng-template>
        <ng-template pTemplate="export" let-item="item">
            <app-button
                styleClass="tableIcon"
                svgIcon="pdf"
                [text]="true"
                (clickEvent)="exportRecord(item)"
            ></app-button>
        </ng-template>
    </app-table>
}
